import { instance as axios } from '../utils/AxiosInstance';

class SignUpService {

    create(email: string, password: string, partnerID: string, programID: string) {
        return axios.post(`/signup`, { email, password, partnerID, programID });    
    }
}

export default new SignUpService();
